export const getAnnexData = (t: (key: string) => string) => [
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.A.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.A.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.B.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.B.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.C.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.C.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.D.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.D.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.E.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.E.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.F.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.F.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.G.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.G.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.H.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.H.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.I.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.I.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.J.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.J.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.K.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.K.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.L.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.L.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.M.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.M.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.N.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.N.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.O.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.O.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.P.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.P.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.Q.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.Q.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.R.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.R.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.S.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.S.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.T.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.T.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.U.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.U.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.NF1.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.NF1.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.NF2.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.NF2.INSTRUCTION'),
  },
  {
    type: t('INSTRUCTIONS.ANNEX_TABLE.NF3.TYPE'),
    instruction: t('INSTRUCTIONS.ANNEX_TABLE.NF3.INSTRUCTION'),
  },
];
